import { Ionicons } from '@expo/vector-icons'
import { createStackNavigator } from '@react-navigation/stack'
import { Icon, useTheme } from 'native-base'
import React from 'react'
import LocalizationContext from '../context/LocalizationContext'
import QRScannerScreen from '../screens/QR/QRScannerScreen'
const QRStack = createStackNavigator()

function QRNavigator(props) {
    const { t } = React.useContext(LocalizationContext)
    const { colors } = useTheme()
    console.log(colors)

    return (
        <QRStack.Navigator
            mode='modal'
            screenOptions={{
                headerStyle: { backgroundColor: colors['primary']['100'], shadowColor: 'transparent' },
                headerTitleStyle: { color: colors['white'] }
            }}
        >

            <QRStack.Screen
                name={'QRScanner'}
                component={QRScannerScreen}
                options={{
                    headerLeft: () => {
                        return <Icon name={'arrow-back'} as={Ionicons} color={colors['white']} size={'sm'} mx={6} onPress={() => { props.navigation.pop() }} />
                    },
                    headerTitle: t('qrScan')
                }}
            />
        </QRStack.Navigator>
    )
}

export default QRNavigator